module.exports = __webpack_public_path__ + "static/media/tawah.2fefbe93.png";